export default function ScrollingBanner() {
  const messages = [
    "🔴 Chaque adoption sauve deux vies : celle de l’animal adopté et celle du prochain recueilli.",
    "🔴 URGENCE : Des animaux attendent une prise en charge.",
    "🔴 Devenez famille d’accueil et changez une vie.",
    "🔴 Soutenez l’association avec un don.",
  ];

  return (
    <div className="w-full overflow-hidden bg-[#f5efe8] rounded-[1rem] py-3">
      <div className="relative flex rounded-[2rem] w-max animate-marquee gap-10 px-6">
        {[...messages, ...messages].map((text, i) => (
          <span
            key={i}
            className="whitespace-nowrap text-sm md:text-base font-medium text-[#d35400]"
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}